export default "__VITE_ASSET__DjId1HMH__"